import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import config from '@constants/index';

const resources = {
  en: {
    common: require('./resources/common-en'),
    eq: require('./resources/eq/en'),
    oss: require('./resources/oss/en'),
    oks: require('./resources/oks/en'),
    ohs: require('./resources/ohs/en')
  },
  de: {
    common: require('./resources/common-de'),
    eq: require('./resources/eq/de'),
    oss: require('./resources/oss/de'),
    oks: require('./resources/oks/de'),
    ohs: require('./resources/ohs/de')
  },
  fr: {
    common: require('./resources/common-fr'),
    eq: require('./resources/eq/fr'),
    oss: require('./resources/oss/fr'),
    oks: require('./resources/oks/fr'),
    ohs: require('./resources/ohs/fr')
  },
  it: {
    common: require('./resources/common-it'),
    eq: require('./resources/eq/it'),
    oss: require('./resources/oss/it'),
    oks: require('./resources/oks/it'),
    ohs: require('./resources/ohs/it')
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: config.DEFAULT_LANGUAGE,
  fallbackLng: 'en',
  load: 'languageOnly',

  interpolation: {
    escapeValue: false
  }
});

export default i18n;
